import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { showSheet } from 'src/actions/SheetActions';
import { CustomText } from 'src/components';
import CustomBottomSheet from 'src/components/bottom-sheet';
import Button from 'src/components/button/Button.componet';
import { isWeb } from 'src/constants';
import { useLocation } from 'src/imports/Router';
import { selectrootsheettype } from 'src/selectors/SheetSelector';
import EmptyBox from '../../../../components/empty-box/EmptyBox.component';
let animationFrameId;

export const MinorProblemSheet = ({}) => {
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );

  const bottomSheetRef = useRef(null);
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  function openHandler() {
    if (isWeb) return;
    bottomSheetRef.current?.expand();
  }

  useEffect(() => {
    switch (sheetId) {
      case 'minorProblem':
        openHandler();
        break;
      default:
        closeBottomSheet();
        break;
    }
  }, [sheetId]);

  function onRequestClose() {
    dispatch(showSheet({sheetId: ''}));
  }

  return (
    <CustomBottomSheet
      onClose={closeBottomSheet}
      ref={bottomSheetRef}
      enablePanDownToClose={isWeb ? undefined : true}
      expandOnContentDrag={isWeb ? true : undefined}
      snapPoints={isWeb ? ({minHeight}) => [1, minHeight] : [244]}
      handleIndicatorStyle={styles.indicator}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                dispatch(showSheet({sheetId: ''}));
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? 244 : undefined}
      open={sheetId !== ''}
      scrollViewStyle={isWeb ? undefined : styles.scroll}
      blocking={isWeb ? true : undefined}
      scrollLocking={isWeb ? false : undefined}>
        <View style={{ height : 244}}>
      <View style={styles.container}>
        <CustomText size={15} font={'700'} color={'#2D2D2D'}>
          {t('vehicle_item_of_this_device_has_a_minor_defect')}
        </CustomText>
        <CustomText mt={8} mb={12} size={11} font={'400'} color={'#2D2D2D'}>
          {t('this_issue_has_been_reported_before_you_and_will_soon_be_resolved')}
        </CustomText>
        <View style={styles.operationContainer}>
        <CustomText size={11} font={'400'} color={'#2D2D2D'}>
          {t('according_to_zeero_operation')}
          {':'}
        </CustomText>
        <CustomText mt={8} size={12} font={'400'} color={'#06AD00'}>
          {t('this_vehicle_is_usable')}
        </CustomText>
        </View>
        <Button
          color={'#fff'}
          onPress={closeBottomSheet}
          style={styles.realizeButton}>
          <CustomText size={16} font={'500'} color={'#202023'}>
            {t('i_realized')}
          </CustomText>
        </Button>
        <EmptyBox height={50}/>
      </View>
      </View>
    </CustomBottomSheet>
  );
};

const styles = StyleSheet.create({
  realizeButton: {
    height: 40,
    paddingVertical : 0 , 
    borderWidth: 1,
    marginBottom: 20,
    borderColor: '#CFCFCF',
  },
  indicator : { 
    width : 72
  }, 
  operationContainer : {
    width  : '100%' , 
    backgroundColor : '#F5FFF5' , 
    borderRadius : 18 , 
    borderWidth : 1 , 
    borderColor : '#EAEAEA' , 
    justifyContent  : 'center' , 
    paddingVertical : 8 , 
    marginBottom : 24 , 
    alignItems : 'center'
  },    
  container: {
    width: '100%',
    height: 204,
    paddingHorizontal: 16,
    justifyContent: 'space-between',
  },
  buttontext: {
    fontSize: 18,
  },
});
